// extracted by mini-css-extract-plugin
export default {"boundsTable":"styles_boundsTable__iyUlo","title":"styles_title__LxnUg","listHeader":"styles_listHeader__vQQV1","listRow":"styles_listRow__E4q9B","body":"styles_body__bVO-z"};